export default {
  arca: {
    menuItem: "ARCA — Factura electrónica",
    title: "ARCA",
    subtitle: "Conexión con ARCA para factura electrónica",
    notInvoicingYet:
      "Esta etapa deja lista la conexión con ARCA. Todavía no se emiten facturas desde la app.",
    environment: "Ambiente",
    envHomologacion: "Homologación",
    envProduccion: "Producción",
    envHomologacionHint: "Pruebas: lo que se hace acá no tiene validez fiscal.",
    envProduccionHint: "Real: los comprobantes tienen validez fiscal.",
    statusConnected: "Conectado",
    statusPending: "Falta configurar",
    statusError: "Con errores",
    next: "Siguiente",
    back: "Anterior",
    stepDone: "Listo",
    steps: {
      fiscal: "Datos fiscales",
      certificate: "Certificado digital",
      authorize: "Autorizar en ARCA",
      sync: "Conectar y sincronizar",
    },
    fiscal: {
      intro:
        "Los datos del contribuyente que va a facturar, tal como figuran en ARCA.",
      cuit: "CUIT",
      cuitInvalid: "El CUIT no es válido (revisá el dígito verificador).",
      razonSocial: "Razón social",
      condicionIva: "Condición frente al IVA",
      choose: "Elegir…",
      responsable_inscripto: "Responsable inscripto",
      monotributo: "Monotributo",
      exento: "Exento",
      domicilioComercial: "Domicilio comercial",
      ingresosBrutos: "Ingresos brutos",
      inicioActividades: "Inicio de actividades",
      invoiceTypes: "Qué vas a facturar",
      wsfe: "Mercado interno",
      wsfeHint: "Facturas {types} (servicio WSFE).",
      wsfeHintNoIva:
        "Facturas A, B o C según tu condición frente al IVA (servicio WSFE).",
      wsfex: "Exportación",
      wsfexHint:
        "Factura E (servicio WSFEX). Necesita un punto de venta propio.",
      puntoVenta: "Punto de venta",
      puntoVentaExportacion: "Punto de venta de exportación",
      puntoVentaHint:
        "El número del punto de venta para web services que vas a usar (o crear) en ARCA.",
      certLockedCuit: "Para cambiar el CUIT, primero quitá los certificados.",
    },
    cert: {
      intro:
        "ARCA identifica a la app con un certificado digital. Nosotros generamos la clave (queda guardada cifrada en el servidor, nunca sale de acá) y un pedido de certificado; vos lo subís en ARCA y nos devolvés el certificado.",
      aliasLabel: "Nombre del certificado (alias)",
      aliasHint: "Así lo vas a ver en ARCA. Solo letras, números y guiones.",
      generate: "Generar pedido de certificado",
      regenerate: "Generar un pedido nuevo",
      downloadCsr: "Descargar pedido (.csr)",
      copyCsr: "Copiar",
      copied: "Copiado",
      csrReady: "Pedido generado el {date}",
      uploadTitle: "Subir el certificado de ARCA",
      uploadHint:
        "El archivo .crt que descargaste de ARCA (o pegá su contenido).",
      chooseFile: "Elegir archivo .crt",
      pasteHere: "-----BEGIN CERTIFICATE-----",
      upload: "Guardar certificado",
      installed: "Certificado instalado",
      alias: "Alias",
      subject: "Titular",
      issuer: "Emitido por",
      validTo: "Vence",
      daysLeft: "faltan {days} días",
      expired: "vencido",
      replace: "Reemplazar certificado",
      remove: "Quitar certificado",
      haveOwn: "Ya tengo certificado y clave",
      haveOwnHint:
        "Si tu contador ya generó un certificado para facturar por web services, subí el .crt y su clave privada (.key, sin contraseña).",
      keyFile: "Elegir clave .key",
      uploadPair: "Guardar certificado y clave",
      howToTitle: "Cómo obtener el certificado en ARCA",
      howToHomo: [
        "Entrá a arca.gob.ar con tu clave fiscal.",
        "Abrí el servicio «WSASS - Autogestión Certificados Homologación» (si no aparece, adheríte desde «Administrador de Relaciones de Clave Fiscal»).",
        "Elegí «Nuevo certificado», poné el alias {alias} y pegá el contenido del pedido (.csr).",
        "Copiá el certificado que te muestra, guardalo como .crt y subilo acá abajo.",
      ],
      howToProd: [
        "Entrá a arca.gob.ar con tu clave fiscal (nivel 3 o superior).",
        "Abrí «Administración de Certificados Digitales» (si no aparece, adherí el servicio desde «Administrador de Relaciones de Clave Fiscal»).",
        "Elegí «Agregar alias», poné {alias} y subí el pedido (.csr) que descargaste.",
        "Entrá al alias, descargá el certificado (.crt) y subilo acá abajo.",
      ],
      confirmReplaceTitle: "¿Reemplazar el certificado?",
      confirmReplaceText:
        "Se genera una clave nueva y el certificado actual deja de servir. Vas a tener que pedir otro en ARCA.",
      confirmRemoveTitle: "¿Quitar el certificado?",
      confirmRemoveText:
        "Se borran la clave y el certificado de este ambiente. La app deja de conectarse con ARCA.",
    },
    authorize: {
      intro:
        "Dos pasos más dentro de ARCA: autorizar el certificado a facturar y tener el punto de venta para web services.",
      serviceTitle: "Autorizar el certificado",
      serviceHomo: [
        "En «WSASS - Autogestión Certificados Homologación», elegí «Crear autorización a servicio».",
        "Elegí el certificado {alias}, poné tu CUIT como representado y el servicio {services}.",
      ],
      serviceProd: [
        "Abrí «Administrador de Relaciones de Clave Fiscal» y elegí «Nueva relación».",
        "Buscá ARCA → WebServices y elegí {services}.",
        "Como representante, elegí el computador fiscal {alias} y confirmá.",
      ],
      serviceDone: "Ya autoricé el servicio",
      pvTitle: "Punto de venta para web services",
      pvHomo:
        "En homologación no hace falta crear el punto de venta: ARCA acepta cualquier número para pruebas.",
      pvProd: [
        "Abrí «Administración de puntos de venta y domicilios» y elegí «Agregar».",
        "Número {numero}, sistema «{sistema}».",
      ],
      pvProdExport:
        "Para exportación, otro punto de venta: número {numero}, sistema «Comprobantes de Exportación - Web Services».",
      pvSistemaRi: "RECE para aplicativo y web services",
      pvSistemaMono: "Factura Electrónica - Monotributo - Web Services",
      pvDone: "Ya tengo el punto de venta",
      wsfeName: "Facturación Electrónica (wsfe)",
      wsfexName: "Factura Electrónica de Exportación (wsfex)",
      and: "y",
      noPvYet: "sin cargar",
    },
    sync: {
      intro:
        "Probamos la conexión de punta a punta sin emitir nada: servidores de ARCA, ingreso con el certificado, punto de venta y último número autorizado.",
      run: "Sincronizar con ARCA",
      running: "Consultando ARCA…",
      lastSync: "Última sincronización: {date}",
      never: "Todavía no se sincronizó en este ambiente.",
      ok: "Todo en orden: la app está conectada con ARCA.",
      failed: "Hay pasos por resolver.",
      puntosVenta: "Puntos de venta en ARCA",
      ultimos: "Último comprobante autorizado",
      noPuntosVenta: "ARCA no devolvió puntos de venta para web services.",
      numero: "Número",
      tipo: "Tipo",
      estado: "Estado",
      activo: "Activo",
      bloqueado: "Bloqueado",
      baja: "De baja",
      service: "Servicio",
      cbte: "Comprobante",
      ultimo: "Último número",
      stepLabels: {
        data: "Datos fiscales",
        certificate: "Certificado",
        servers: "Servidores de ARCA",
        auth: "Ingreso con el certificado",
        puntoVenta: "Punto de venta",
        ultimo: "Numeración",
      },
      serviceNames: {
        wsfe: "Mercado interno",
        wsfex: "Exportación",
      },
    },
  },
};
